<app-ip-title-mobile
  [title]="'IP.SIDENAV.OPTIONS.FINANCES_OPTIONS.MANAGE' | translate" 
  ></app-ip-title-mobile>
<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  animationDuration="0ms"
  class="custom-tabs">
  <mat-tab [label]="'IP.CONSOLIDATED.GENERATED_TITLE' | translate">
    <app-fn-consolidated></app-fn-consolidated>
  </mat-tab>
  <mat-tab [label]="'IP.CONSOLIDATED.PAID_TITLE' | translate"  >
    <app-fn-paid-orders></app-fn-paid-orders>
  </mat-tab>
</mat-tab-group>